// Central registry of Gurugram service areas used for local-SEO landing pages.
// Each entry becomes /laundry/<slug> with keyword-targeted meta + H1.
// Add nearby-landmark hints to give unique body copy per page (avoids doorway-page penalties).

export const SECTORS = [
  { slug: "sector-14",       name: "Sector 14",        nearby: ["Old DLF Colony", "Galleria Market", "Huda City Centre"] },
  { slug: "sector-15",       name: "Sector 15",        nearby: ["Sushant Lok", "Rajesh Pilot Marg"] },
  { slug: "sector-22",       name: "Sector 22",        nearby: ["Palam Vihar", "Bijwasan Road"] },
  { slug: "sector-23",       name: "Sector 23",        nearby: ["Palam Vihar Extn.", "Ansal Palam Vihar"] },
  { slug: "sector-29",       name: "Sector 29",        nearby: ["Leisure Valley", "Cyber Hub"] },
  { slug: "sector-40",       name: "Sector 40",        nearby: ["Vipul World", "Sohna Road"] },
  { slug: "sector-43",       name: "Sector 43",        nearby: ["Central Park", "Rapid Metro Sector 43"] },
  { slug: "sector-45",       name: "Sector 45",        nearby: ["Vipul Belmonte", "Uniworld Garden"] },
  { slug: "sector-46",       name: "Sector 46",        nearby: ["South City II", "Ardee City"] },
  { slug: "sector-47",       name: "Sector 47",        nearby: ["Uppals Southend", "Malibu Towne"] },
  { slug: "sector-48",       name: "Sector 48",        nearby: ["Central Park Resorts", "Uppal Southend"] },
  { slug: "sector-49",       name: "Sector 49",        nearby: ["Nirvana Country", "Uniworld Garden 2"] },
  { slug: "sector-50",       name: "Sector 50",        nearby: ["Central Park Resorts", "Nirvana Courtyard"] },
  { slug: "sector-52",       name: "Sector 52",        nearby: ["Suncity", "South City II"] },
  { slug: "sector-54",       name: "Sector 54",        nearby: ["Sun City", "Golf Course Road Metro"] },
  { slug: "sector-55",       name: "Sector 55",        nearby: ["Golf Course Road", "Suncity Township"] },
  { slug: "sector-56",       name: "Sector 56",        nearby: ["Rosewood City", "Beverly Park"] },
  { slug: "sector-57",       name: "Sector 57",        nearby: ["Sushant Lok III", "Unitech South City"] },
  { slug: "sector-65",       name: "Sector 65",        nearby: ["Golf Course Extension Road", "Emerald Estate"] },
  { slug: "sector-67",       name: "Sector 67",        nearby: ["Adani Oyster Grande", "Vatika India Next"] },
  { slug: "sector-70",       name: "Sector 70",        nearby: ["Central Park Flower Valley", "Southern Peripheral Road"] },
  { slug: "sector-82",       name: "Sector 82",        nearby: ["Vatika India Next", "SPR Road"] },
  { slug: "sector-89",       name: "Sector 89",        nearby: ["M3M Woodshire", "New Gurugram"] },
  {
    slug: "dlf-phase-1", name: "DLF Phase 1",
    nearby: ["Qutub Plaza", "Silver Oaks Park", "Nathupur"],
    complexes: ["Silver Oaks", "Beverly Park I", "Ridgewood Estate", "Windsor Court", "Hamilton Court"],
    landmarks: ["Qutub Plaza", "Silver Oaks Park", "DPS Sector 45 corridor"],
    intro: "DLF Phase 1 is one of Gurugram's oldest planned enclaves — Silver Oaks, Ridgewood, Beverly Park and Windsor Court residents have relied on us for their weekly wash-and-iron rhythm.",
  },
  {
    slug: "dlf-phase-2", name: "DLF Phase 2",
    nearby: ["Sikanderpur Metro", "The Grand Mall", "Cyber Greens"],
    complexes: ["Regency Park I", "Regency Park II", "Icon Hotel", "Princeton Estate", "Belvedere Tower"],
    landmarks: ["Sikanderpur Rapid Metro", "The Grand Mall", "MG Road corridor"],
    intro: "DLF Phase 2 sits right on the Sikanderpur–MG Road spine. Regency Park, Princeton Estate and Belvedere residents book us on the way to Cyber Hub — we handle pickup, we handle Monday.",
  },
  {
    slug: "dlf-phase-3", name: "DLF Phase 3",
    nearby: ["Cyber Hub", "Cyber City", "Ambience Mall", "Chakkarpur"],
    complexes: ["Silver Oaks", "The Pinnacle", "The Belaire", "The Aralias", "Trinity Tower"],
    landmarks: ["DLF Cyber City", "Ambience Mall", "Cyber Hub food court"],
    intro: "DLF Phase 3 wraps around Cyber City — from Silver Oaks to The Belaire, our runners already know the tower lobbies and gate protocols. Same-day rush works best here since we're 10 minutes from the studio.",
  },
  {
    slug: "dlf-phase-4", name: "DLF Phase 4",
    nearby: ["Galleria Market", "Wembley Estate", "Silver Oaks", "Sector 27"],
    complexes: ["Wembley Estate", "Windsor Court", "Rosewood City", "Regency Park", "Silver Oaks"],
    landmarks: ["Galleria Market", "DLF Golf Course", "Sultanpur Road"],
    intro: "DLF Phase 4 residents around Galleria Market and Wembley Estate use us for everything from silk sarees to Peloton towels. We pair Galleria pickups with the Sector 27–43 runner route so slots stay tight.",
  },
  {
    slug: "dlf-phase-5", name: "DLF Phase 5",
    nearby: ["The Aralias", "The Camellias", "The Magnolias", "Golf Course Road"],
    complexes: ["The Aralias", "The Camellias", "The Magnolias", "The Belaire", "The Pinnacle", "The Icon"],
    landmarks: ["DLF Golf & Country Club", "Trump Towers Delhi NCR", "Golf Course Road"],
    intro: "DLF Phase 5 is the Aralias–Camellias–Magnolias corridor along Golf Course Road. We run a dedicated concierge lane here — everything is bagged in fabric totes, invoices are shared over WhatsApp, and delicate/designer garments go through Premium Care by default.",
  },
  { slug: "cyber-hub",       name: "Cyber Hub",        nearby: ["DLF Cyber City", "Ambience Mall", "IFFCO Chowk"] },
  { slug: "palam-vihar",     name: "Palam Vihar",      nearby: ["Ansal API Palam Vihar", "Sector 22", "Bijwasan Road"] },
  {
    slug: "sushant-lok", name: "Sushant Lok",
    nearby: ["Sushant Lok I", "Sushant Lok II", "Sushant Lok III", "MG Road"],
    complexes: ["Sushant Lok I", "Sushant Lok II", "Sushant Lok III", "Uniworld City", "The Vipul Belmonte"],
    landmarks: ["Sushant Lok I market", "Huda City Centre Metro", "MG Road"],
    intro: "Sushant Lok is our densest pickup cluster — three phases, hundreds of villas and low-rises, everything on our morning route between Sector 43 and MG Road. Perfect for weekly plans since our runners land in the neighbourhood twice a day.",
  },
  {
    slug: "golf-course-road", name: "Golf Course Road",
    nearby: ["The Camellias", "Icon Hotel", "Sector 42", "Sector 43", "Sector 54"],
    complexes: ["The Camellias", "The Aralias", "The Magnolias", "Central Park I", "Ireo The Grand Arch", "M3M Golfestate"],
    landmarks: ["DLF Golf & Country Club", "Rapid Metro Golf Course Road", "Sector 42 clubhouse"],
    intro: "Golf Course Road is a 5-kilometre premium spine from Sikanderpur to Sector 55. From The Camellias to Ireo Grand Arch, we offer a valet-style pickup: fabric totes, hangered delivery, and Premium Care as the default for designer wear.",
  },
  { slug: "sohna-road",      name: "Sohna Road",       nearby: ["Central Park", "Sector 48", "Rosewood City"] },
  { slug: "mg-road",         name: "MG Road",          nearby: ["MG Road Metro", "MGF Metropolitan", "Sahara Mall"] },
];

export const SECTOR_BY_SLUG = Object.fromEntries(SECTORS.map((s) => [s.slug, s]));
export const SECTOR_BY_NAME = Object.fromEntries(SECTORS.map((s) => [s.name, s]));

export function findSector(slugOrName) {
  if (!slugOrName) return null;
  const key = String(slugOrName).trim();
  return SECTOR_BY_SLUG[key.toLowerCase()] || SECTOR_BY_NAME[key] || null;
}
